import type React from 'react';

import { Toolbar, SaveButton } from 'react-admin';

import type { SaveButtonProps, ToolbarProps } from 'react-admin';

type SimpleSaveToolbarProps = ToolbarProps & {
  saveProps?: Partial<SaveButtonProps>;
};

/**
 * A simple toolbar that contains only a save button.
 */
export const SimpleSaveToolbar = ({ saveProps, ...toolbarProps }: SimpleSaveToolbarProps): React.ReactElement => {
  return (
    <Toolbar {...toolbarProps}>
      <SaveButton {...saveProps} />
    </Toolbar>
  );
};
